import { LogIn, Newspaper, ShieldCheck } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AdminLogin() {
  const login = () => {
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[#0F172A] flex items-center justify-center px-4 relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.04]" style={{ backgroundImage: "radial-gradient(circle, #fff 1px, transparent 1px)", backgroundSize: "22px 22px" }} />
      <div className="relative w-full max-w-md bg-white rounded-2xl p-8 sm:p-10 shadow-2xl">
        <div className="text-center mb-8">
          <div className="w-14 h-14 rounded-full bg-[#0F172A] flex items-center justify-center mx-auto mb-4">
            <Newspaper className="text-white" size={26} />
          </div>
          <h1 className="font-headline text-3xl font-black text-[#0F172A]">Le Véridique</h1>
          <p className="meta-label text-slate-400 mt-1">Espace rédaction sécurisé</p>
        </div>

        <button onClick={login} data-testid="google-login-button"
          className="w-full flex items-center justify-center gap-3 bg-[#0F172A] text-white py-3.5 rounded-full font-sub font-semibold hover:bg-[#1E293B] transition-colors">
          <LogIn size={18} /> Se connecter avec Google
        </button>

        <div className="flex items-start gap-2 mt-6 text-slate-400">
          <ShieldCheck size={16} className="mt-0.5 shrink-0" />
          <p className="font-body text-xs leading-relaxed">
            Accès réservé aux membres de la rédaction (administrateurs, éditeurs, journalistes). Authentification sécurisée via Google.
          </p>
        </div>
      </div>
    </div>
  );
}
